// Since our domains have a subdomain, we sometimes need to remove it
export const getBaseHostname = () => {
  const urlParts = location.hostname.split('.');
  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.');
};
